<template>
    <div
        class="md face"
        :class="classStr"
    >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            classStr: {
                type: String,
                required: false
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.face {
        text-align: center;
        margin-top: 60px;

        span {
            font-size: $font-size-xl;
        }

        &::after {
            $size: 120px;

            @extend %font-pseudo;
            display: block;
            margin-top: $interval-l;
            line-height: $size;
            height: $size;
            font-size: $size;
        }

        &.is-good {
            $type: map-get($colors, 'success');
            $text: map-get($type, 'text');

            span {
                color: $major-color;
            }

            &::after {
                content: '\e7f2';
            }
        }

        &.is-bad {
            $type: map-get($colors, 'danger');
            $text: map-get($type, 'text');

            span {
                color: $text;
            }

            &::after {
                content: '\e7f3';
            }
        }

        &.is-problem {
            $type: map-get($colors, 'normal');
            $text: map-get($type, 'text');

            span {
                color: $text;
            }

            &::after {
                content: '\e812';
            }
        }
    }
</style>
